import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class NewsletterService {

  private baseUrl = global.url + 'newsletter';

  constructor(
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

  private getHeaders(): HttpHeaders {
    const token = this.cookieService.get('auth_token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'licencia': token
    });
  }

  // ===== Plantillas =====

  getTemplates(): Observable<any> {
    return this.http.get(`${this.baseUrl}/templates`, { headers: this.getHeaders() });
  }

  getTemplate(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/templates/${id}`, { headers: this.getHeaders() });
  }

  createTemplate(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/templates`, data, { headers: this.getHeaders() });
  }

  updateTemplate(id: number, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/templates/${id}`, data, { headers: this.getHeaders() });
  }

  deleteTemplate(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/templates/${id}`, { headers: this.getHeaders() });
  }

  // ===== Campañas =====

  getCampaigns(): Observable<any> {
    return this.http.get(`${this.baseUrl}/campaigns`, { headers: this.getHeaders() });
  }

  getCampaign(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/campaigns/${id}`, { headers: this.getHeaders() });
  }

  createCampaign(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns`, data, { headers: this.getHeaders() });
  }

  updateCampaign(id: number, data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/campaigns/${id}`, data, { headers: this.getHeaders() });
  }

  deleteCampaign(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/campaigns/${id}`, { headers: this.getHeaders() });
  }

  sendTest(id: number, email: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns/${id}/test`, { email }, { headers: this.getHeaders() });
  }

  sendCampaign(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns/${id}/send`, {}, { headers: this.getHeaders() });
  }

  scheduleCampaign(id: number, scheduledAt: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns/${id}/schedule`, { scheduledAt }, { headers: this.getHeaders() });
  }

  cancelCampaign(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns/${id}/cancel`, {}, { headers: this.getHeaders() });
  }

  getMetrics(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/campaigns/${id}/metrics`, { headers: this.getHeaders() });
  }

  getRecipients(id: number, page: number = 0, size: number = 20): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get(`${this.baseUrl}/campaigns/${id}/recipients`, {
      headers: this.getHeaders(),
      params
    });
  }

  // ===== Preview / Audience =====

  previewHtml(htmlContent: string, sampleName?: string, sampleEmail?: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/campaigns/preview`,
      { htmlContent, sampleName, sampleEmail },
      { headers: this.getHeaders() });
  }

  previewAudience(segmentType: string, segmentValue?: string): Observable<any> {
    let params = new HttpParams().set('segmentType', segmentType);
    if (segmentValue) {
      params = params.set('segmentValue', segmentValue);
    }
    return this.http.get(`${this.baseUrl}/campaigns/audience/preview`, {
      headers: this.getHeaders(),
      params
    });
  }
}

